import ApiService from '../ApiService'

const printerPreviewService = {

    // savePDF (data) {
    //     return ApiService.post('print-preview/savePDF', data)
    // },

    savePDF(data) {
        return ApiService.customRequest({
            url: 'print-preview/savePDF',
            method: 'post',
            data: data,
            responseType: 'blob'
        });
    },

    getUploads (id) {
        return ApiService.get(`print-preview/getUpload/${id}`)
    }

}

export default printerPreviewService
